import { render, staticRenderFns } from "./CompareRack.vue?vue&type=template&id=37b8efcb&"
import script from "./CompareRack.vue?vue&type=script&lang=js&"
export * from "./CompareRack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports